import { createSlice } from '@reduxjs/toolkit';

const sidebarReducer = createSlice({
  name: 'sidebar',
  initialState: {
    show: true,
    unfoldable: false,
  },
  reducers: {
    toggleSidebar(state, { payload }) {
      state.show = payload;
    },
  },
});

const { reducer, actions } = sidebarReducer;
export const { toggleSidebar } = actions;

export default reducer;
